import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import vuetify from './plugins/vuetify'
import * as io from 'socket.io-client'
import VueSocketIO from 'vue-socket.io'
import store from './store/store'

Vue.use(
  new VueSocketIO({
    debug: false,
    // connection: io.connect('http://localhost:3000')
    connection: io.connect('https://lets-vote-server.fly.dev/')
  })
)

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
